import { render } from "./checkStandardBattery.vue?vue&type=template&id=213ff0e2&scoped=true&ts=true"
import script from "./checkStandardBattery.vue?vue&type=script&lang=ts"
export * from "./checkStandardBattery.vue?vue&type=script&lang=ts"

import "./checkStandardBattery.vue?vue&type=style&index=0&id=213ff0e2&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213ff0e2"]])

export default __exports__